import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {}, // start empty
})

export async function loadLocaleMessages(locale) {
    try {
        const messages = await import(`./locales/${locale}.json`)
        i18n.global.setLocaleMessage(locale, messages.default)

        // only set locale AFTER messages exist
        i18n.global.locale.value = locale
        localStorage.setItem('lang', locale)
    } catch (error) {
        console.error(`Failed to load messages for locale: ${locale}`, error)
    }
}

export default i18n
